import { baseQueryWithLogout } from "@/lib/baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { Kpi } from "./kpi.type";

export const KpiApi = createApi({
  reducerPath: "kpiApi",
  tagTypes: ["kpi"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getKpi: build.query<Kpi, void>({
      query: () => "kpis",
      providesTags: ["kpi"],
    }),
  }),
});

export const { useGetKpiQuery } = KpiApi;
